import styled from 'styled-components';
export var OperatorsList = styled.div.withConfig({
  displayName: "FilterOperatorstyles__OperatorsList",
  componentId: "keen-query-creator__sc-1lrbgsc-0"
})(["&&&{width:210px;}"]);
export var Container = styled.div.withConfig({
  displayName: "FilterOperatorstyles__Container",
  componentId: "keen-query-creator__sc-1lrbgsc-1"
})(["&&&{position:relative;white-space:nowrap;}"]);